import styled from 'styled-components'
import { Link } from 'react-router-dom';

export const AboutContainer = styled.div`
  background: #000;
  color: #000;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  position: relative;
`;


export const RowOneContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;


export const TopLine = styled.div`
  margin-top: 24px;
  width: 400px;
  color: #cc8f2d;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

export const VideoWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: flex;
    position: relative;
    z-index: 1;
    width: 60%;
`;

export const ReactPlayer = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
`;


export const NavBtnLink = styled(Link)`
  border-radius: 50px;
  background: #cc8f2d;
  white-space: nowrap;
  margin-bottom: 20px;
  padding: 10px 22px;
  color: #010606;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #010606;
  }
`;
